export default function moat() {
  return `
  <script src="https://s3.amazonaws.com/assets.fastcompany.com/assets/js/vendor/keywee/keywee.js" async ></script>
  `;
}
